import { render, staticRenderFns } from "./DodEmployees.vue?vue&type=template&id=063d4078&scoped=true&"
import script from "./DodEmployees.vue?vue&type=script&lang=js&"
export * from "./DodEmployees.vue?vue&type=script&lang=js&"
import style0 from "./DodEmployees.vue?vue&type=style&index=0&id=063d4078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d4078",
  null
  
)

export default component.exports